<template>
  <gg-card>
    <gg-card-header>Service Add-ons</gg-card-header>
    <gg-card-text>
      <v-data-table
        v-if="addons.length"
        :headers="headers"
        :items="addons"
      >
        <template v-slot:item.name="{ item }">
          <div>
            {{ item.name }}<br />
            <small class="text--secondary">{{ item.domain }}</small>
          </div>
        </template>
        <template v-slot:item.renewalcost="{ item }">
          ${{ item.renewalcost }}
        </template>
        <template v-slot:item.renewaldate="{ item }">
          {{ formatRenewalDate(parseRenewalDate(item.renewaldate)) }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-icon class="pb-1" :color="statusColor(item.status)">mdi-circle</v-icon>
          {{ item.status }}
        </template>
        <template v-slot:item.actions="{ item }">
          <gg-btn @click="goToCancellation(item.id, item.cancellation_id)">{{ item.cancellation_pending ? 'View Cancellation' : 'Stop Renewal' }}</gg-btn>
        </template>
      </v-data-table>
      <v-alert v-else type="info" class="ma-0">
        No Addons purchased.
      </v-alert>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { statusColor, parseRenewalDate, formatRenewalDate } from '@/helpers/helpers'
import { cancellationTypes } from '@/consts/cancellations'

export default {
  name: 'HostingAddons',
  data () {
    return {
      headers: [
        {
          text: 'Addon',
          value: 'name',
          class: 'table-heading-sm',
        },
        {
          text: 'Price',
          value: 'renewalcost',
        },
        {
          text: 'Billing Cycle',
          value: 'renewalterm',
        },
        {
          text: 'Due Date',
          value: 'renewaldate',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Actions',
          value: 'actions'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['hosting', 'services']),
    addons () {
      return this.services.filter(item => item.related_service === this.hosting.id)
    },
  },
  methods: {
    statusColor,
    parseRenewalDate,
    formatRenewalDate,
    goToCancellation (addonId, cancellationId) {
      if (cancellationId) {
        this.$router.push(`/cancellations/${cancellationId}`)
        return
      }
      this.$router.push({
        name: 'cancel',
        params: {
          service_id: addonId,
        },
        query: {
          type: cancellationTypes.ADDON,
          r_s: this.hosting.id
        }
      })
    }
  }
}
</script>
